var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlacklisted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12L12 6",
    stroke: "#E80A0F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34075 15.0908L2.9085 12.6585C2.487 12.237 2.25 11.6647 2.25 11.0677V6.93225C2.25 6.33525 2.487 5.763 2.90925 5.3415L5.3415 2.90925C5.763 2.487 6.33525 2.25 6.93225 2.25H11.0677C11.6647 2.25 12.237 2.487 12.6585 2.90925L15.0915 5.34225C15.513 5.76375 15.75 6.336 15.75 6.933V11.0677C15.75 11.6647 15.513 12.2363 15.0915 12.6585L12.6592 15.0915C12.237 15.513 11.6647 15.75 11.0677 15.75H6.93225C6.33525 15.75 5.763 15.513 5.34075 15.0908V15.0908Z",
    stroke: "#E80A0F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlacklisted);
export default __webpack_public_path__ + "static/media/Blacklisted.75bb46c108c230c75a43b351c72f3f11.svg";
export { ForwardRef as ReactComponent };